import {get, isEmpty} from '@yandex-delivery/utils'

import type {LaunchResponse, Point} from 'src/shared/types'

export function withCorrectPointContact(point: Point, userInfo?: LaunchResponse) {
  const contact = get('contact', point)
  const phone = get('passport_account.details.phones[0].phone', userInfo)

  return phone && isEmpty(contact.phone) ? {...contact, phone} : contact
}
